import { styled } from "simplydo/react/styled";
import { mobileOnly } from "simplydo/react/theme";

const SettingsActionDiv = styled.div`
  margin-top: 30px;
  text-align: right;

  ${mobileOnly} {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

type SettingActionsProps = { children: React.ReactNode };

function SettingActions({ children }: SettingActionsProps) {
  return <SettingsActionDiv>{children}</SettingsActionDiv>;
}

export default SettingActions;
